import React, { useState } from 'react';
import Tags from '../../Components/Tags/Tags';
import { useSelector } from 'react-redux';
import { setTags } from '../slice';

const TagsSection = (props) => {
  const tags = useSelector((state: any) => state.productSet.tags.tags);

  const [inputTags, setInputTags] = useState('');

  return (
    <Tags
      disabled={props.disabled}
      setInputTags={setInputTags}
      tags={tags}
      setTags={setTags}
      inputTags={inputTags}
    />
  );
};
export default TagsSection;
